import { FC } from "react";
import React from "react";
import Picture from "../../assets/images/family.png";

import { makeStyles } from "@material-ui/core";
import { Colors } from "../../styles";

const useStyles = makeStyles(() => ({
    container: {
        position: "relative",
        textAlign: "center",
    },
    picture: {
        borderStyle: "none",
        borderWidth: 0,
        objectFit: "contain",
        backgroundBlendMode: "multiply",
        backgroundImage: "linear-gradient(to bottom, rgba(0, 0, 0, 0.53), rgba(0, 0, 0, 0))",
    },

    itemColumn: {
        fontFamily: "innogyWEB",
        textAlign: "left",
        fontSize: 55,
        fontWeight: 500,
        fontStretch: "normal",
        fontStyle: "normal",
        lineHeight: "normal",
        letterSpacing: "normal",
        color: Colors.white,
        position: "absolute",
        top: "6.5%",
        left: "12%",
        transform: "translate(-6.5%, -12%)",
    },
}));

export const FamilyPicture: FC = () => {
    const classes = useStyles();
    return (
        <div className={classes.container}>
            <img alt="" className={classes.picture} src={Picture} />
            <div className={classes.itemColumn}>Der Weg zu Ihrem Netzanschluss</div>
        </div>
    );
};
